<template>
  <div v-if="loaded">
    <div class="home-container">
      <img class="logo mb-4 mt-8" src="/logo.png" />
      <div class="box">
        <h4 class="text-right my-4" style="font-weight: 400">
          کیک سهام مورد نظر را انتخاب کنید:
        </h4>

        <div @click="$router.push('/add-pie')" class="pie-box">
          <div class="image-box">
            <img src="/add-pie.png" />
          </div>
          <div class="pt-5 px-3">ایجاد کیک سهام جدید</div>
        </div>
        <div
          @click="goToPie(item)"
          v-for="(item, index) in allPies"
          :key="index"
          class="pie-box"
        >
          <div class="image-box">
            <img
              :src="item.pictureUrl ? item.pictureUrl : '/slicingPie-logo.png'"
            />
          </div>
          <div class="pt-5 px-3">{{ item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
export default {
  data() {
    return {
      email: "",
      password: "",
      remember: false,
      busy: false,
      loaded: false,
      allPies: [],
    };
  },
  methods: {
    goToPie(item) {
      this.$router.push("/home/" + item.id);
      localStorage.setItem("selectedPie", item.id);
      localStorage.setItem("role", item.userRole);
      localStorage.setItem("restriction", item.restriction);
      localStorage.setItem("ownerId", item.pieUserId);
      localStorage.setItem("lastVisit", item.lastVisitToPie);
    },
    getAllPies() {
      this.busy = true;
      this.$http
        .get(this.baseUrl + "/pies/listForUser", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.allPies = res.data;
            this.busy = false;
            this.loaded = true;
          } else {
            this.toast("خطا: مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.busy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
  },
  mounted() {
    if (localStorage.getItem("selectedPie")) {
      this.$router.push("/home/" + localStorage.getItem("selectedPie"));
    } else {
      this.getAllPies();
    }
  },
};
</script>

<style lang="scss"></style>
